import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkbox"
export default class extends Controller {
  connect() {
    let checkboxes = document.querySelectorAll('input[type=checkbox]');
    const checkSpan = '<span class="checkmark"></span>';
    checkboxes.forEach(box => {
      box.insertAdjacentHTML('afterend', checkSpan);
    });
  }
}
